import type { PreSignedUrlResponse } from "app/components/MediaUploader/types";
import { FILE_API_URL } from "utils/constants";
import { request } from "utils/request";

type FetchAttachmentReadUrlParams = {
  assetId: string;
  fileName: string;
  filePath?: string;
  existingUrl?: string;
};

export const isAttachmentReadUrl = (url?: string | null): boolean => {
  if (!url) return false;
  const normalized = url.toLowerCase();
  if (normalized.includes("x-id=putobject")) return false;
  if (normalized.includes("x-amz-algorithm=")) {
    return normalized.includes("x-id=getobject");
  }
  return true;
};

export const attachmentPreviewUrl = (
  response: PreSignedUrlResponse | null | null,
  fallbackurl?: string,
): string | null => {
  if (response?.url && isAttachmentReadUrl(response.url)) {
    return response.url;
  }

  if (fallbackurl && isAttachmentReadUrl(fallbackurl)) {
    return fallbackurl;
  }

  return null;
};

export async function fetchAttachmentReadUrl({
  assetId,
  fileName,
  filePath,
  existingUrl,
}: FetchAttachmentReadUrlParams): Promise<string | null> {
  if (existingUrl && isAttachmentReadUrl(existingUrl)) {
    return existingUrl;
  }

  const response = await request(`${FILE_API_URL}asset/signed-url`, {
    method: "POST",
    body: JSON.stringify({
      assetId,
      fileName,
      ...(filePath ? { filePath } : {}),
    }),
  });

  if (response.err || !response.data) {
    return null;
  }

  return attachmentPreviewUrl(
    response.data as PreSignedUrlResponse,
    existingUrl,
  );
}
